/**
 * Some utilities about the Artwork set view, extracted here
 * to avoid cluttering up the artwork.tsx page component.
 */

import { getOneArtworkSet } from "@/api/ensemble/ensemble";
import { useAdditionalFilters } from "@/context/additional-filters/AdditionalFiltersContext";
import { useQuery } from "@tanstack/react-query";

const useArtworkSet = () => {
  const filters = useAdditionalFilters();

  const { data: setData } = useQuery({
    queryFn: () => getOneArtworkSet(filters?.setId as string),
    enabled: filters?.setId != undefined,
    queryKey: ["ensemble", filters?.setId],
  });

  return {
    artworkSet: setData,
    isInArtworkSet: filters?.setId != undefined,
  };
};

export default useArtworkSet;
